import * as Sentry from "@sentry/browser";
const { logger } = Sentry;

// safely stringify deep / circular objects
function safeStringify(obj, indent = 2) {
    const seen = new WeakSet();
    return JSON.stringify(obj, (key, val) => {
        if (typeof val === 'object' && val !== null) {
            if (seen.has(val)) return '[Circular]';
            seen.add(val);
        }
        return val;
    }, indent);
}

export default async function handlerErrorFromApis(error) {
    const status = error?.response?.status;

    // Network / no-response case
    if (!error?.response) {
        if (window.location.pathname === '/wallet-deposit') {
            const { code, config } = error;

            // Timeout / abort
            if (code === 'ECONNABORTED') {
                logger.info('API call aborted', {
                    error: safeStringify(error)
                });
                return;
            }

            // Build payloadData, but for key="image" grab only metadata
            const payloadData = {};
            const data = config?.data;

            if (data instanceof FormData) {
                for (const [key, value] of Array.from(data.entries())) {
                    if (key === 'image' && value instanceof File) {
                        // only metadata, not file contents
                        payloadData[key] = {
                            lastModified: value.lastModified,
                            lastModifiedDate: value.lastModifiedDate,
                            name: value.name,
                            size: value.size,
                            type: value.type,
                            webkitRelativePath: value.webkitRelativePath
                        };
                    } else {
                        payloadData[key] = value;
                    }
                }
            } else if (data && typeof data === 'object') {
                Object.assign(payloadData, data);
            };

            logger.error('API call error', {
                error: safeStringify(error),
                payload: payloadData
            });
        }

        return Promise.reject([
            `${status ? status : `C ${error?.response}`} Error: Check your NETWORK again and refresh the page.`
        ]);
    }

    // HTTP-response errors
    switch (status) {
        case 422:
            if (error.response.data.details) {
                const firstKey = Object.keys(error.response.data.details)[0];
                return Promise.reject(
                    `Error ${status}: ${error.response.data.details[firstKey]}`
                );
            } else {
                return Promise.reject(`Error ${status}: ${error.response.data.message}`);
            }

        case 401:
            clearDataOnUnauthorised();
            break;

        case 400:
        case 500:
            return Promise.reject([
                `Error ${status}: ${error.response.data.error ||
                error.response.data.errors ||
                error.response.data.message
                }`
            ]);

        default:
            return Promise.reject([`Error ${status}: Refresh the page and try again.`]);
    }
}

function clearDataOnUnauthorised() {
    window.cookies.keys().forEach(cookie => window.cookies.remove(cookie));
    window.store.dispatch('resetAllState');
    window.router.push({ name: 'Home' });
}
